"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuNoMarginDivider = exports.VSelectMultiple = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var core_1 = require("@blueprintjs/core");
var select_1 = require("@blueprintjs/select");
require("@blueprintjs/select/lib/css/blueprint-select.css");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var styled_components_1 = __importDefault(require("styled-components"));
var style_2 = require("../../SelectionList/style");
var clearToken = "$empty#Option#first#item_unique_";
var ItemSelect = select_1.Select.ofType();
var filterItem = function (query, value) {
    return ("".concat(value.item.label).toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
        (value && value.item && value.item.value === clearToken));
};
exports.VSelectMultiple = (0, mobx_react_1.observer)(function (props) {
    var selectedItem = (0, react_1.useRef)();
    var changed = (0, react_1.useRef)();
    var noChangeToClear = (0, react_1.useRef)();
    var usedClear = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(null), activeItem = _a[0], setActiveItem = _a[1];
    var _b = (0, react_1.useState)([]), selectedItems = _b[0], setSelectedItems = _b[1];
    var _c = (0, react_1.useState)(false), isOpenPopover = _c[0], setIsOpenPopover = _c[1];
    var _d = (0, react_1.useState)(''), query = _d[0], setQuery = _d[1];
    var ref = (0, react_1.useRef)(null);
    var renderItem = function (_a, _b) {
        var _c, _d;
        var item = _a.item, selectedItems = _a.selectedItems;
        var handleClick = _b.handleClick, modifiers = _b.modifiers;
        if (!modifiers.matchesPredicate) {
            return null;
        }
        var active = ((_c = activeItem === null || activeItem === void 0 ? void 0 : activeItem.item) === null || _c === void 0 ? void 0 : _c.value) && item.value === ((_d = activeItem === null || activeItem === void 0 ? void 0 : activeItem.item) === null || _d === void 0 ? void 0 : _d.value);
        var founded = selectedItems.some(function (selected) { return selected.value === item.value; });
        var isSelectable = item.selectable !== false;
        return (react_1.default.createElement(core_1.MenuItem, { icon: founded ? 'tick' : 'blank', disabled: !isSelectable || modifiers.disabled, label: item.rep, active: active && isSelectable, key: item.value, onClick: isSelectable ? handleClick : undefined, text: item.label, shouldDismissPopover: item.value === clearToken, style: !isSelectable ? { opacity: 0.5, cursor: 'not-allowed' } : undefined, labelElement: item.value === clearToken && item.label === 'No Selection' ? (react_1.default.createElement(core_1.Icon, { color: (active && 'white') || '#7486949c', icon: 'reset' })) : null }));
    };
    (0, react_1.useEffect)(function () {
        if (props.fieldState) {
            var ids = (props.fieldState && (0, mobx_1.toJS)(props.fieldState.value)) || [];
            updateSelectItems(ids);
        }
    }, [props.fieldState && props.fieldState.value]);
    (0, react_1.useEffect)(function () {
        if (props.value) {
            var ids = (props.value && props.value) || [];
            updateSelectItems(ids);
        }
    }, [props.value]);
    var updateSelectItems = function (ids) {
        var selectedItemss = props.options.filter(function (option) {
            if (ids && Array.isArray(ids) && ids.length > 0) {
                return ids.some(function (id) { return id.toString() === option.value.toString(); });
            }
            return false;
        });
        setSelectedItems(selectedItemss);
    };
    var getFieldText = function () {
        if (selectedItems.length === 1) {
            return selectedItems[0].label;
        }
        if (selectedItems.length > 1) {
            return "".concat(selectedItems.length, " Items selected");
        }
        return props.defaultText || 'No selection';
    };
    var selectOrDeselectItem = function (value, callBack) {
        if (value && value.value !== clearToken) {
            var outerIndex_1 = -1;
            if (selectedItems &&
                Array.isArray(selectedItems) &&
                selectedItems.length > 0) {
                selectedItems.some(function (item, index) {
                    var result = item.value.toString() === value.value.toString();
                    if (result) {
                        outerIndex_1 = index;
                    }
                    return result;
                });
            }
            if (outerIndex_1 === -1) {
                selectedItems.push(value);
            }
            else {
                selectedItems.splice(outerIndex_1, 1);
            }
            setSelectedItems(selectedItems);
        }
        else if (props.allowEmptyItem && value && value.value === clearToken) {
            setActiveItem({
                item: (0, lodash_1.get)(getOptions(), '[0]', {}),
                selectedItems: []
            });
            setSelectedItems([]);
        }
        if (callBack) {
            callBack();
        }
    };
    var renderMenu = function (_a) {
        var items = _a.items, itemsParentRef = _a.itemsParentRef, query = _a.query, renderItem = _a.renderItem;
        var renderedItems = items.map(renderItem).filter(function (item) { return item != null; });
        var itemsToRender = props.allowEmptyItem &&
            renderedItems.length > 0 &&
            selectedItems &&
            selectedItems.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null, renderedItems.map(function (item, index) {
            if (index === 0) {
                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    item,
                    react_1.default.createElement(core_1.MenuDivider, { key: "divider_$index", className: 'dividerNoMargin' })));
            }
            return item;
        }))) : (renderedItems);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.StyledMenuNoMarginDivider, { ulRef: itemsParentRef }, renderedItems.length > 0 ? (itemsToRender) : (react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." })))));
    };
    var getOptions = function () {
        var options = props.options, allowEmptyItem = props.allowEmptyItem;
        var newOptions = (options &&
            options.length > 0 &&
            (props.allowOrder
                ? (0, lodash_1.orderBy)(options, ['label'], [props.orderDirection || false])
                : options)) ||
            [];
        if (allowEmptyItem &&
            options &&
            options.length > 0 &&
            selectedItems &&
            selectedItems.length > 0) {
            return __spreadArray([{ value: clearToken, label: 'No Selection' }], newOptions, true);
        }
        return newOptions;
    };
    var onItemSelected = function (value) {
        var _a, _b;
        if (((_a = value === null || value === void 0 ? void 0 : value.item) === null || _a === void 0 ? void 0 : _a.selectable) === false) {
            return;
        }
        if (usedClear.current) {
            noChangeToClear.current = true;
            usedClear.current = false;
        }
        if (((_b = value === null || value === void 0 ? void 0 : value.item) === null || _b === void 0 ? void 0 : _b.value) === clearToken) {
            usedClear.current = true;
        }
        else {
            selectedItem.current = value === null || value === void 0 ? void 0 : value.item;
        }
        var itemValue = props.allowEmptyItem && value && value.item && value.item.value;
        var updateFieldState = function () {
            if (props.fieldState) {
                var ids = selectedItems.map(function (item) { return item.value; });
                fieldState.onChange(itemValue === clearToken ? [] : ids);
            }
            if (props.onChange) {
                var ids = selectedItems.map(function (item) { return item.value; });
                props.onChange(itemValue === clearToken ? [] : ids);
            }
        };
        selectOrDeselectItem(value.item, updateFieldState);
    };
    var label = props.label, labelInfo = props.labelInfo, fieldState = props.fieldState, disabled = props.disabled, inline = props.inline, rightIcon = props.rightIcon, id = props.id, icon = props.icon, filterable = props.filterable, layer = props.layer, fill = props.fill, noLabel = props.noLabel, required = props.required, validators = props.validators, fixedInputWidthPx = props.fixedInputWidthPx, iconOnly = props.iconOnly, minimal = props.minimal, margin = props.margin, tipLabel = props.tipLabel, tooltip = props.tooltip, displayRequired = props.displayRequired, popoverMinimal = props.popoverMinimal, popoverProps = props.popoverProps;
    if (fieldState) {
        if (required) {
            if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
            }
            else {
                fieldState.validators(Validators_1.Validators.required);
            }
        }
        else if (validators && validators.length > 0) {
            fieldState.validators.apply(fieldState, validators);
        }
    }
    var renderOptions = getOptions().map(function (item) { return ({ item: item, selectedItems: selectedItems }); });
    var handleInteraction = function (nextOpenState) {
        setIsOpenPopover(nextOpenState);
    };
    var onClear = function () {
        setQuery('');
    };
    var renderClearButton = function () { return (react_1.default.createElement(core_1.Button, { style: { width: '30px' }, minimal: true, onClick: onClear, rightIcon: 'filter-remove' })); };
    var areItemsEqual = function (itemA, itemB) {
        var _a, _b;
        return ((_a = itemA.item) === null || _a === void 0 ? void 0 : _a.value) === ((_b = itemB.item) === null || _b === void 0 ? void 0 : _b.value);
    };
    var clearActive = function () {
        var _a;
        if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('previousFocusedElement')) {
            ref.current.previousFocusedElement = undefined;
        }
        setActiveItem(null);
        changed.current = true;
    };
    return (react_1.default.createElement(style_1.StyledPopOverWrapper, { disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, fixedInputWidthPx: fixedInputWidthPx, margin: margin },
        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
            tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
            react_1.default.createElement(ItemSelect, { ref: ref, activeItem: activeItem, onActiveItemChange: function (value) {
                    if (!changed.current) {
                        if (selectedItem.current) {
                            setActiveItem({
                                item: selectedItem.current,
                                selectedItems: []
                            });
                            if (noChangeToClear.current) {
                                noChangeToClear.current = false;
                            }
                            else {
                                selectedItem.current = null;
                            }
                        }
                        else {
                            setActiveItem(value);
                        }
                        changed.current = true;
                    }
                    else {
                        changed.current = false;
                    }
                }, popoverProps: __assign({ minimal: popoverMinimal, captureDismiss: true, isOpen: isOpenPopover, onInteraction: handleInteraction, onOpening: clearActive, onClosing: clearActive, modifiers: {
                        flip: { enabled: true },
                        keepTogether: { enabled: true },
                        preventOverflow: { enabled: true }
                    }, shouldReturnFocusOnClose: false }, popoverProps), itemPredicate: filterItem, itemRenderer: renderItem, items: renderOptions, disabled: disabled, itemsEqual: areItemsEqual, itemListRenderer: renderMenu, noResults: react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." }), onItemSelect: onItemSelected, filterable: filterable, resetOnClose: props.resetOnClose && props.resetOnClose, onQueryChange: function (value) { return setQuery(value); }, query: query || '', inputProps: {
                    rightElement: renderClearButton()
                }, className: props.isLoading ? core_1.Classes.SKELETON : '' }, iconOnly ? (react_1.default.createElement(core_1.Button, __assign({ className: minimal ? 'bp3-minimal' : '', style: { justifyContent: 'center' } }, {
                icon: icon,
                disabled: disabled
            }, { text: iconOnly && undefined }))) : (react_1.default.createElement(core_1.Button, __assign({ className: minimal ? 'bp3-minimal' : '' }, {
                icon: icon,
                disabled: disabled
            }, { rightIcon: rightIcon || 'chevron-down', text: getFieldText() })))))));
});
exports.StyledMenuNoMarginDivider = (0, styled_components_1.default)(style_2.NoFocusMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .dividerNoMargin {\n    margin: 0;\n  }\n"], ["\n  & .dividerNoMargin {\n    margin: 0;\n  }\n"])));
var templateObject_1;
